import React from 'react';
import Menu from './Menu';
import Foot from './Foot';
import '../Styles/Courier.css';
import bagIllustration from '../Images/bag1.png';

const Courier = () => {
	return (
		<div className="Courier-page">
			<header>
				<Menu id="Menu" className="row-container"/>
			</header>
			<main id="Courier">
				<h1>Courier Options</h1>
				<div className="courier-options">
					<section id="Paxi" className="courier-option">
						<div className="row-container">
							<h3>1</h3>
							<h2> <a target="_blank" href="https://paxi.co.za" rel="noopener noreferrer">Paxi</a></h2>
						</div>
						<p className="description">Pep store to pep store</p>

						<div className="paxi courier-details">
							<li><span>Duration:</span><span> 5-9 days</span></li>
							<li><span>Price:</span><span> R70</span></li>

						</div>
						<div className="courier-instructions">
							<ol className="steps">
								<li> I will drop your parcel in-store at a Pep nearby me and it will be sent to a Pep store closest to you or any Pep store of your choice </li>
								<li> I will get a tracking number and I will send it to you so you can track your parsel on their website </li>
								<li> Once your parcel is ready for clilection, myself or you will be notified via SMS to receive a OTP </li>
								<li> When collecting your parcel don't forget to bring along your <mark className="highlight"> One Time Pin</mark> and <mark className="highlight">Proof of Identity</mark> </li>
							</ol>
						</div>
					</section>
					<section id="Aramex" className=" courier-option">
						<div className="row-container">
							<h3>2</h3>
							<h2><a target="_blank" href="https://aramex.co.za" rel="noopener noreferrer">Aramex</a></h2>
						</div>
						<p className="description">Selected Pick'n Pay, freshtop and Checkers To your location</p>

						<div className="aramex courier-details">
							<li><span>Duration:</span> <span>2-3 days</span> </li>
							<li><span>Price:</span> <span>R105</span> </li>

						</div>
						<div className="courier-instructions">
							<ol>
								<li>
									I will drop your parcel at a Pick n Pay, Freshtop or Checkers nearby me. Then it will be sent to your door, all you need to do is send me the address you want me to send it to/
									I Unfortunately can't send it to a P.O. box because you need to sign for it.
								</li>
								<li>
									I will receive a tracking number and it will be sent to you so you can track where your parcel is on their website
								</li>
								<li>
									You should be notified when your parcel will be arriving and all you need to do is sign that you have received your parcel.	
								</li>
							</ol>
						</div>

						{/*Illustration by <a href="https://icons8.com/illustrations/author/5c07e68d82bcbc0092519bb6">Icons 8</a> from <a href="https://icons8.com/illustrations">Ouch!</a>*/}

					</section>
					<section id="Collect" className="courier-option">
						<div className="row-container">
							<h3>3</h3>
							<h2>Collect</h2>
						</div>

						<p className="description">Pick up your parcel at your convenience</p>
						<ul className="click-collect courier-details">
							<div className="row-container"> 
							 <span>Address &emsp;</span>
							 <span>
							 	5 Tarry Road <br/>
							 	Alrode South <br/>
							 	Alberton 
							 </span>
							 </div>
						</ul>

						<div className="courier-instructions">
							<p>The sign that says Plastelle Plastics is the building I will be at</p> 
							<aside><mark>Reminder!</mark> you can pay cash for your order when you collect</aside>
						</div>
					</section>
				</div>
				<div className="notices">
					<section className="notice-container" >

						<div className="build-a-bag">
							<h2>Build-a-bag</h2>
							<p>
								<mark>
									You are more than welcome to "build a bag". How it works is that if you have a few items that you would put into one parcel I will keep the bag for you until you want it to be sent out to you. 
									Advantages of this option is that you save your money and the environment!!
								</mark>
							</p>
						</div>
						<div className="image-container">
							<img className="bag-illustration" src={bagIllustration} alt="shopping bag illustration"/>
						</div>

					</section>
					<section className="notice-container ">
						
						<div className="reminder">
							<h2>Please note!</h2>
							<p>
								<mark>
									All parcels will be sent out on Mondays, Wednesdays and Fridays. Also a reminder that you can come
									collect your order (just give me a days notice when you will be coming to collect)
								</mark>
							</p>
						</div>
					</section>
					<section className="farewell">

						<p>Have a great day!</p> 
							

					{/*heart vector image*/}
					</section>
					
				</div>
			</main>
			<footer className="centered">
				<Foot/>
			</footer>
		</div>
	)
}

export default Courier;